<template>
	<div :class="['how-it-works', {'how-it-works--on-white': onWhite}, 'how-it-works--type-' + type]">
		<div class="how-it-works--items">
			<div
				v-for="(item, i) in howItWorksItems"
				:class="{'how-it-works--item': true, 'how-it-works--item-non-free': item.free === false}"
			>
				<div class="how-it-works--item-number">
					<span>{{ i + 1 }}</span>
				</div>
				<div v-if="item.free !== undefined" class="how-it-works--item-free-info">
					<span>{{ item.free ? 'Gratis' : 'Faire Preise' }}</span>
				</div>
				<div class="how-it-works--item-text">{{ item.text }}</div>
				<ul class="how-it-works--item-items">
					<li v-for="(listItem, j) in item.items" :key="'list-item-' + i + '-' + j">
						<Icon icon="checkmark"/>
						{{ listItem }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";

const TYPE__APPLICATION = 'application';
const TYPE__CUSTOMER = 'customer';

const HOW_IT_WORKS_ITEMS_CUSTOMER = [
	{
		text: 'Jobprofil veröffentlichen',
		items: [
			'schnell mit wenigen Klicks',
			'einfach'
		],
		free: true,
	},
	{
		text: 'Best-Match-System zeigt passende Bewerber',
		items: [
			'einfach Notizen erstellen',
			'passende Personen vormerken'
		],
		free: true,
	},
	{
		text: 'Kontaktanfragen',
		items: [
			'annehmen',
			'senden'
		],
		free: false,
	},
	{
		text: 'Weitere Jobprofile anlegen und veröffentlichen',
		items: [
			'unbeschränkte Anzahl',
			'noch weniger Zeitaufwand'
		],
		free: true,
	},
	{
		text: 'Termine',
		items: [
			'vereinbaren',
			'zusagen',
			'absagen'
		],
		free: true,
	},
];

const HOW_IT_WORKS_ITEMS_APPLICATION = [
	{
		text: 'Wünsche und Skills eintragen',
		items: [
			'schnell mit wenigen Klicks',
			'einfach'
		],
	},
	{
		text: 'Best-Match-System zeigt passende Jobs',
		items: [
			'einfach Notizen erstellen',
			'interessante Jobs vormerken'
		],
	},
	{
		text: 'Kontaktanfragen',
		items: [
			'annehmen',
			'senden'
		],
	},
	{
		text: 'Termine',
		items: [
			'vereinbaren',
			'zusagen',
			'absagen'
		],
	},
];

export default {
	components: {Icon},

	props: {
		type: {
			type: String,
			required: false,
			default: TYPE__CUSTOMER
		},
		onWhite: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	computed: {
		howItWorksItems ()
		{
			return this.type === TYPE__APPLICATION ? HOW_IT_WORKS_ITEMS_APPLICATION : HOW_IT_WORKS_ITEMS_CUSTOMER;
		}
	}
}
</script>
